<inbox-inbox>
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</inbox-inbox>
<bc-global-notification [message]="globalNotificationMessage()"></bc-global-notification>
